/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_CreateInputs */

const cs_settings_teams_create = /** @type {(inputs: Settings_Teams_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit tým`)
};

const en_settings_teams_create = /** @type {(inputs: Settings_Teams_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create team`)
};

/**
* | output |
* | --- |
* | "Create team" |
*
* @param {Settings_Teams_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_create = /** @type {((inputs?: Settings_Teams_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_create(inputs)
	return cs_settings_teams_create(inputs)
});